/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
/* eslint-disable no-duplicate-imports */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { IPromoBannerViewProps } from './citta-promo-banner';

const PromoBannerView: React.FC<IPromoBannerViewProps> = props => {
    const {
        promoBannerProps,
        contentProps,
        closeButton,
        bannerMessages,
        PromoBannerTextProps,
        PromoBannerLinksProps,
        CarouselProps,
        handleLinks,
        handleText
    } = props;
    const slides = bannerMessages && bannerMessages.map((message, index) => {
        if (message.links?.length) {
            return ( 
                <Node {...contentProps} key={index}>
                    {message.text && <a href={message.links![0].linkUrl.destinationUrl}><Node {...PromoBannerTextProps} text={message.text} onClick={handleText} /></a>}
                    {message.links && message.links.length > 0 && <Node {...PromoBannerLinksProps} links={message.links} onClick={handleLinks} />}
                </Node>
            );
        }
        return (
            <Node {...contentProps} key={index}>
                {message.text && <Node {...PromoBannerTextProps} text={message.text} onClick={handleText} />}
                {message.links && message.links.length > 0 && <Node {...PromoBannerLinksProps} links={message.links} onClick={handleLinks} />}
            </Node>
        );
    });
    if(bannerMessages.length > 0){
        return (
            <Module {...promoBannerProps}>
                <Node {...CarouselProps} items={slides} />
                {closeButton}
            </Module>
        );
    }
    return null;
};
export default PromoBannerView;
